var opvWrap = $('#opv-wrap');
var opVideo = $('#opv').get(0);
var video = $('#opv');
var windowSp = window.matchMedia('(max-width:1024px)').matches;

var videoElement = $('.top-intro-video');
var keyvisualElement = $('.top-keyvisual-image');
var $videoPlay = $('#videoPlay');
var $videoEnded = $('#videoEnded');

$(document).on('ready', function () {
  setTimeout(function () {
    videoElement.fadeIn(1000);
  }, 500);
});

// 最初にSKIPだけ表示、REPEATは非表示
$videoPlay.show();
$videoEnded.hide();

// 再生中にSKIPを表示、REPEATを隠す
opVideo.addEventListener('play', function () {
  $videoPlay.show();
  $videoEnded.hide();
});



// 停止時にSKIPを隠し、REPEATを表示し、キービジュアルを表示する
opVideo.addEventListener('pause', function () {
  $videoPlay.hide(); // SKIPボタンを隠す
  $videoEnded.show(); // REPEATボタンを表示
});



opVideo.addEventListener('ended', function () {
  opVideo.pause(); // 再生を止める（終端のフレームで停止）

  setTimeout(function(){
      videoElement.css('opacity','0'); // 動画は表示したまま
      keyvisualElement.css('opacity','1'); // キービジュアルを出さない
  }, 1000);
});

// SKIPを押したら動画を最後に飛ばして停止（最後のカットで止める）
$('#skip').on('click', function () {
  

  // 表示の切り替え（動画非表示、キービジュアル表示）
  videoElement.css('opacity','0');
  keyvisualElement.css('opacity','1');
});

// REPEATを押したら動画再生をリセット
$('#repeat').on('click', function () {
  // header.fadeOut();
  // ★追加: display: none; を解除して要素を再表示する
  videoElement.show(); // または videoElement.css('display', 'block');

  videoElement.css('opacity','1'); // 動画コンテナを確実に表示 (既にあった処理)
  keyvisualElement.css('opacity','0'); // キービジュアルを非表示
  
  opVideo.currentTime = 0;
  opVideo.muted = true;
  opVideo.play();
  
});

function movieSwitch() {
  if (windowSp) {
    // video.attr('src', 'images/video/260115_fermo-toyoda_mv_sp.mp4');
    video.attr('src', 'images/video/260611_sp.mp4');
  } else {
    video.attr('src', 'images/video/260611.mp4');
    
  }
}

movieSwitch();


